module.exports = __webpack_public_path__ + "static/images/e-star.79a7640.png";